import mock from './mock';
import './navbar/navbarSearch';
import './navbar/navbarBookmarkSearch';
import './auth/authentication';
mock.onAny().passThrough();
